import { NavLink } from "react-router-dom";
import "../../../styles/adminDashboard.css";
import {
  AVAILABILITY_STATUSES,
  LISTING_STATUSES,
  SORT_OPTIONS,
  formatListingStatus,
} from "../../../constants/automapDealerInventoryConstants";
import { DUPLICATE_STATUS_LABELS, LISTING_NOTE_TYPES, LISTING_NOTE_TYPE_LABELS } from "../../../constants/automapAdminListingConstants";

export { LISTING_NOTE_TYPES, LISTING_NOTE_TYPE_LABELS, DUPLICATE_STATUS_LABELS };

export function AdminListingNav({ active }) {
  const items = [
    { key: "list", label: "Todos", href: "/admin/listings" },
    { key: "review", label: "Revisión", href: "/admin/listings/review" },
    { key: "stale", label: "Obsoletos", href: "/admin/listings/stale" },
    { key: "missing-photos", label: "Sin fotos", href: "/admin/listings/missing-photos" },
    { key: "duplicates", label: "Duplicados", href: "/admin/listings/duplicates" },
    { key: "outliers", label: "Atípicos", href: "/admin/listings/outliers" },
  ];
  return (
    <nav className="admin-console__nav-tabs">
      {items.map((item) => (
        <NavLink key={item.key} to={item.href} className={({ isActive }) => (isActive || active === item.key ? "is-active" : undefined)}>
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}

export function ListingFilters({ filters, onChange }) {
  const set = (key, value) => onChange({ ...filters, [key]: value });
  return (
    <div className="admin-filters" style={{ display: "flex", flexWrap: "wrap", gap: "0.75rem", marginBottom: "1rem" }}>
      <input type="search" placeholder="Buscar vehículo" value={filters.search || ""} onChange={(e) => set("search", e.target.value)} />
      <input placeholder="Dealer ID" value={filters.dealerId || ""} onChange={(e) => set("dealerId", e.target.value)} />
      <input placeholder="Ciudad" value={filters.city || ""} onChange={(e) => set("city", e.target.value)} />
      <input placeholder="Marca" value={filters.make || ""} onChange={(e) => set("make", e.target.value)} />
      <select value={filters.status || ""} onChange={(e) => set("status", e.target.value)}>
        <option value="">Estado</option>
        {LISTING_STATUSES.map((s) => <option key={s} value={s}>{formatListingStatus(s)}</option>)}
      </select>
      <select value={filters.availabilityStatus || ""} onChange={(e) => set("availabilityStatus", e.target.value)}>
        <option value="">Disponibilidad</option>
        {AVAILABILITY_STATUSES.map((s) => <option key={s} value={s}>{formatListingStatus(s)}</option>)}
      </select>
      <select value={filters.sort || "updated_desc"} onChange={(e) => set("sort", e.target.value)}>
        {SORT_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        <option value="created_asc">Más antiguo</option>
        <option value="mileage_desc">Mayor km</option>
        <option value="confirmed_asc">Confirmación más antigua</option>
        <option value="lead_count_desc">Más leads</option>
        <option value="view_count_desc">Más vistas</option>
      </select>
      <label><input type="checkbox" checked={filters.missingPhotos === "true"} onChange={(e) => set("missingPhotos", e.target.checked ? "true" : "")} /> Sin fotos</label>
      <label><input type="checkbox" checked={filters.stale === "true"} onChange={(e) => set("stale", e.target.checked ? "true" : "")} /> Obsoleto</label>
      <select value={filters.riskLevel || ""} onChange={(e) => set("riskLevel", e.target.value)}>
        <option value="">Nivel de riesgo</option>
        <option value="low">Riesgo bajo</option>
        <option value="medium">Revisar con cuidado</option>
        <option value="high">Requiere revisión</option>
        <option value="unavailable">No disponible</option>
        <option value="unknown">Información limitada</option>
      </select>
      <label><input type="checkbox" checked={filters.hasBuyerVisibleRisk === "true"} onChange={(e) => set("hasBuyerVisibleRisk", e.target.checked ? "true" : "")} /> Riesgo visible al comprador</label>
      <label><input type="checkbox" checked={filters.hasAdminOnlyRisk === "true"} onChange={(e) => set("hasAdminOnlyRisk", e.target.checked ? "true" : "")} /> Riesgo solo admin</label>
      <label><input type="checkbox" checked={filters.trustSafetyFlagged === "true"} onChange={(e) => set("trustSafetyFlagged", e.target.checked ? "true" : "")} /> Trust &amp; safety</label>
      <label><input type="checkbox" checked={filters.highRisk === "true"} onChange={(e) => set("highRisk", e.target.checked ? "true" : "")} /> Alto riesgo</label>
    </div>
  );
}

export function formatCop(value) {
  if (value == null) return "—";
  return new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", maximumFractionDigits: 0 }).format(value);
}

export function formatDate(iso) {
  if (!iso) return "—";
  return new Intl.DateTimeFormat("es-CO", { dateStyle: "short", timeStyle: "short" }).format(new Date(iso));
}

export function vehicleSummary(listing) {
  return [listing.year, listing.make, listing.model, listing.version].filter(Boolean).join(" ");
}

export function ConfirmDialog({ open, title, message, onConfirm, onCancel, confirmLabel = "Confirmar", children }) {
  if (!open) return null;
  return (
    <div className="admin-dialog-backdrop" role="dialog">
      <div className="admin-dialog">
        <h3>{title}</h3>
        {typeof message === "string" ? <p>{message}</p> : message}
        {children}
        <div className="admin-console__header-actions">
          <button type="button" className="admin-btn" onClick={onCancel}>Cancelar</button>
          <button type="button" className="admin-btn admin-btn--primary" onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}

export function queueFromPathname(pathname) {
  if (pathname.includes("/review")) return "review";
  if (pathname.includes("/stale")) return "stale";
  if (pathname.includes("/missing-photos")) return "missing-photos";
  if (pathname.includes("/duplicates")) return "duplicates";
  if (pathname.includes("/outliers")) return "outliers";
  return null;
}

export function trackListingAdminEvent(eventType, metadata = {}) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[admin-listing-event]", eventType, metadata);
  }
}
